import React, { useState, useEffect } from "react";
import { Modal } from "@mui/material";
import "./component-styles.scss";
import closeIcon from "../../assets/common/closeWithText.png";
import suscessIcon from "../../assets/suscessIcon.svg";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import swal from "sweetalert";
import Loader from "../UI Component/Loader/Loader";

function CallInitiatedModal({openCallInitiatedView, openCallInitiatedCloseView}) {
  return (
    <>
    {/* {loading && <Loader />} */}
    <Modal
      open={openCallInitiatedView}
      aria-labelledby="contained-modal-title-vcenter"
    >
    <div className="d-flex justify-content-center align-items-center h-100">
      <div className="call-initiated-modal-wrapper">
        <div className="call-modal" style={{padding: "20px 50px 0px 50px"}}>
          <div className="header" style={{display: "flex", justifyContent: "center"}}>
            <img src={suscessIcon} alt="suscessIcon" style={{width: "77px", height: "77px"}}/>
          </div>
          <p className="call_initiated_font" >
            Call Initiated Successfully!
          </p>
        </div>
      </div>
    </div>
    </Modal>
    </>
  );
}

export default CallInitiatedModal;
